import React, { useState } from "react";
import styled from "styled-components";
import logo from "~/assets/i/logo.svg";
import { Alert, Link, Modal, Text } from "~/components-shared";
import Footer from "~/components/Footer";
import { useTranslation } from "react-i18next";
import mixpanel from "mixpanel-browser";
import SignUpVerifyCodeModal from "~/components/SignUpVerifyCodeModal";
import { useHistory } from "react-router-dom";
import { RoutesEnum } from "~/types/enums";
import SignUpCompany from "~/components/SignUpCompany";
import SignUpMember from "~/components/SignUpMember";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import signUpCompanySchema from "~/forms/SignUpCompanyForm/signUpCompanySchema";
import signUpMemberSchema from "~/forms/SignUpMemberForm/signUpMemberSchema";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
const Section = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
`;
const Branding = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.step * 7;
}}px;
`;
const Logo = styled.img`
  margin-right: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.step;
}}px;
`;
const Content = styled.div`
  padding: 1em;
  display: flex;
  overflow-y: auto;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;
const Wrapper = styled.div`
  max-width: 280px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-items: center;
  align-items: center;
  flex-direction: column;
`;
const SignUp = () => {
  const [verify, setVerify] = useState(false);
  const [step, setStep] = useState(0);
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const history = useHistory();
  const {
    handleSubmit,
    setValue,
    getValues
  } = useForm({
    resolver: yupResolver(signUpCompanySchema.concat(signUpMemberSchema))
  });
  const onSubmit = handleSubmit(data => {
    setIsLoading(true);
    api.verifySignUpSendCode({
      email: data.email
    }).then(() => {
      setVerify(true);
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setIsLoading(false);
    });
    mixpanel.track(`Sign-up – Submit`, {
      ...data
    });
  });
  const handleLoginClick = () => {
    history.push(RoutesEnum.ROOT);
  };
  const onCompanySubmit = companyData => {
    setValue("companyName", companyData.companyName);
    setValue("email", companyData.email);
    setStep(1);
  };
  const onMemberSubmit = memberData => {
    setValue("firstName", memberData.firstName);
    setValue("lastName", memberData.lastName);
    setValue("password", memberData.password);
    setValue("repeatPassword", memberData.repeatPassword);
    onSubmit();
  };
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Branding, null, /*#__PURE__*/React.createElement(Logo, {
    src: logo,
    alt: "Joyn",
    width: 40
  }), /*#__PURE__*/React.createElement("h2", null, "Joyn")), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), step === 0 && /*#__PURE__*/React.createElement(SignUpCompany, {
    onSubmit: onCompanySubmit
  }), step === 1 && /*#__PURE__*/React.createElement(SignUpMember, {
    onSubmit: onMemberSubmit,
    isLoading: isLoading
  }), /*#__PURE__*/React.createElement(Link, {
    onClick: handleLoginClick,
    color: "textSecondary",
    s: {
      mb: 3
    },
    weight: "semiBold",
    underline: true
  }, t("SignUp.logIn")), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    align: "center"
  }, t("SignUp.disclaimer")))), /*#__PURE__*/React.createElement(Footer, null), /*#__PURE__*/React.createElement(Modal, {
    open: verify
  }, /*#__PURE__*/React.createElement(SignUpVerifyCodeModal, {
    formData: getValues(),
    onClose: () => setVerify(false)
  })));
};
export default SignUp;